interface CheckboxMultipleProps {
  label: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  image?: string;
  containerClassName?: string;
  className?: string;
  labelClassName?: string;
  setTrigger?: (value: boolean) => void;
}

const CheckboxMultiple = ({
  label,
  value,
  onChange,
  checked,
  image,
  containerClassName = '',
  className = 'checkbox-wrapper-others',
  labelClassName = '',
  setTrigger = () => {},
}: CheckboxMultipleProps) => {
  return (
    <div className={`flex justify-between items-center mb-2 ${containerClassName}`}>
      <div className={`flex gap-3 items-center ${className}`}>
        <input
          className="form-check-input"
          type="checkbox"
          name="dataCheckbox"
          value={value}
          id={'flexCheckDefault' + label}
          onChange={onChange}
          checked={checked}
          onClick={() => {
            setTrigger(true);
          }}
        />
        {image && <img src={image} width={72} height={45} />}
        <label
          className={`form-check-label ${labelClassName}`}
          htmlFor={'flexCheckDefault' + label}
        >
          {label}
        </label>
      </div>
    </div>
  );
};

export default CheckboxMultiple;
